import { render, staticRenderFns } from "./Age.vue?vue&type=template&id=47e91724&scoped=true"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"
import style0 from "./Age.vue?vue&type=style&index=0&id=47e91724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e91724",
  null
  
)

export default component.exports